gAds();
document.onreadystatechange = function() {
    if (document.readyState === 'interactive') {
        addLoader();
    } else if (document.readyState === 'complete') {
        redirectPage(6);
    }
};

function sendSentryMessage(text) {
    if (typeof Sentry !== 'undefined') {
        Sentry.captureMessage(text);
    } else {
        console.error('Sentry is not loaded or event has been blocked');
    }
}

function redirectPage(i) {
    var cookie_exist = checkIfCookieExist();
    var ga_exist = true;
    var fb_events_exist = typeof fbq !== 'undefined';
    var loaded = false;

    if (ga_exist && cookie_exist && fb_events_exist) {
      //  ga(function() { 
            loaded = true;
      //  });
    } else {
        if (!ga_exist) {
            console.error('ga or ga.create is undefined ' + '(' + i + ')');
            if (i === 0) {
                sendSentryMessage('ga or ga.create is undefined ' + '(' + i + ')');
            }
        }
        if (!cookie_exist) {
            console.error('bbp_lf cookie doesn\'t exist ' + '(' + i + ')');
            if (i === 0) {
                sendSentryMessage('bbp_lf cookie doesn\'t exist ' + '(' + i + ')');
            }
        }
        if (!fb_events_exist) {
            console.error('fb event functions doesn\'t exist ' + '(' + i + ')');
            if (i === 0) {
                sendSentryMessage('fb event functions doesn\'t exist ' + '(' + i + ')');
            }
        }
    }

    if (!loaded && i > 0) {
        setTimeout(function() {
            redirectPage(i - 1);
        }, 1000);
    } else {
        if (!loaded) {
            console.error('redirect - 7 failed attempts');
            sendSentryMessage('redirect - 7 failed attempts');
        }

        var url = document.querySelector('.redirect__url').getAttribute('data-redirect-url');
        if (fb_events_exist) {
            var fb_uuid = create_UUID();
            fbq("trackCustom", "Gateway", {eventID: fb_uuid});
            url = addUuidToUrl(url, fb_uuid);
        }else {
            sendSentryMessage('FB events script not loaded');
        }
        window.location.href = url;
    }
};

function checkIfCookieExist() {
    return document.cookie.indexOf('bbp_lf=') !== -1 ? true : false;
};

function addLoader() { 
    var loader = document.querySelector('.redirect__loader');
    for(var i = 0; i < 3; i++) {
        var span = document.createElement('span');
        span.classList.add('circle');
        loader.appendChild(span);
    }

    var i = 0;
    setInterval(function() {
        var circles = document.querySelectorAll('.redirect__loader .circle');
        for (var j = 0; j < circles.length; j++) {
            circles[j].classList.remove('-active');
        }
        circles[i].classList.add('-active');
        i++;
        if(i === 3) {
            i = 0;
        }
    }, 150);
};

function gAds() {
    try {
        var url = new URL(window.location.href);
        if (url.searchParams) {
            var amount = url.searchParams.get("amount");
            var period = url.searchParams.get("period");
            var type = url.searchParams.get("type");

            if (amount && period && type) {
                var id = type + '/' + amount + '/' + period;
                window.dataLayer.push({
                    'event': 'add_to_cart',
                    'value': amount,
                    'items': [{
                        'id': id,
                        'google_business_vertical': 'custom'
                    }]
                });
            }
        }
    } catch (error) {
        sendSentryMessage(error);
    }
}

function addUuidToUrl(url, uuid) {
    url = new URL(url);
    return url + (url.search ? '&': '?') + 'fb_lead_event_uuid=' + uuid;
}

function create_UUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}
